import { Box } from '@mui/material'
import React from 'react'
import logo from '../assets/images/logo/LogoName-2.svg'

function Logo({ width, height }) {
  return (
    <Box component="img" src={logo}
        sx={{ width: width, height: height }}
    />
  )
}

export default Logo